export default "__VITE_ASSET__Bxq4u26y__"